module.exports = __webpack_public_path__ + "img/cbr2rn1.91abfbf7.gif";